export default {
    byPodcast(id) {
        return this.transformer.many(
            this.try(
                this.baseQuery().where('podcastId', id).get()
            )
        )
    }
}
